'use strict';

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': ' + attribute.value + '</div>';
            });
        }
    });

    return html;
}
/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    var $attr = '[data-attr="' + attr.id + '"]';
    var $defaultOption = $productContainer.find($attr + ' .select-' + attr.id + ' option:first');
    $defaultOption.attr('value', attr.resetUrl);

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find($attr + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue.attr('value', attrValue.url).removeAttr('disabled');

        if (!attrValue.selectable) {
            $attrValue.attr('disabled', true);
        }
    });
}
/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = '<li><div>' + response.resources.info_selectforstock + '</div></li>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<li><div>' + message + '</div></li>';
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources,
    });
}
/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' + attrValue.value + '"]');
        var $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        }
    });
}
/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['color'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}
/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find('.product-options').empty().html(optionsHtml);
}

function updateButtons(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find('.cc-prod-tile__buttons').empty().html(optionsHtml);
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVaraint;
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item').data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item').data('ready-to-order', response.product.readyToOrder);
        }
    }
    //Update Product Id on both Tile and Tile detail sections
    $($productContainer).find('.js-prod-tile').attr('data-pid', response.product.id);
    $($productContainer).find('.js-prod-tile-notify').attr('data-pid', response.product.id);
    $($productContainer).attr('data-pid', response.product.id);
    $($productContainer).find('.cc-prod-tile__name a').attr('href', response.product.selectedProductUrl);

    //Update Product Name and Link of image
    $($productContainer).find('.cc-prod-tile__name').text(response.product.productName);
    $($productContainer).find('.cc-prod-tile__img__tag').attr('alt', '');
    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $('.price', $productContainer);
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product,
            $productContainer: $productContainer,
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.js-tile-quick-add-btn, button.quick-add-to-cart-global, button.update-cart-product-global')
            .trigger('product:updateAddToCart', {
                product: response.product,
                $productContainer: $productContainer,
            })
            .trigger('product:statusUpdate', response.product);
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty().html(getAttributesHtml(response.product.attributes));
}

function attributeSelect(selectedValueUrl, $productContainer, $selectedButton) {
    if (selectedValueUrl) {
        $('body').trigger('product:beforeVariationSelect', { url: selectedValueUrl, container: $productContainer });

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                handleVariantResponse(data, $productContainer);
                updateButtons(data.product.buttonsHtml, $productContainer);
                updateOptions(data.product.optionsHtml, $productContainer);
                $('body').trigger('product:afterVariationSelect', { data: data, container: $productContainer, button: $selectedButton });

                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            },
        });
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl($productContainer) {
    if ($productContainer && $productContainer.length) {
        var url = $productContainer.find('.quick-add-to-cart-url').val();
        if (url) return url;
    }
    return $('.quick-add-to-cart-url').val();
}
function getPidValue($el) {
    var pid;
    pid = $($el).closest('.js-prod-tile').attr('data-pid');
    return pid;
}

function getSuggestedPidValue($el) {
    var pid;
    pid = $($el).closest('.js-suggested-prod-tile').attr('data-pid');
    return pid;
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10),
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]').data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: "" + selectedValueId,
            };
        })
        .toArray();

    return JSON.stringify(options);
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            },
        });
    }
}

function handleError() {
    const $errorToast = $('.js-errorToast');

    if ($('body').hasClass('modal-open')) {
        $('body').find('.cc-modal.show').modal('hide');
    }

    $errorToast.removeClass('d-none').addClass('show');

    const headerHeight = $('.cc-header').height() || 0;
    const scrollAnimateOffset = $errorToast.offset().top - headerHeight - 30;

    $('html, body').animate({ scrollTop: scrollAnimateOffset }, 500);

    setTimeout(function () {
        $errorToast.removeClass('show').addClass('d-none');
    }, 3000);
    $.spinner().stop();
}

export function selectAttribute() {
    $(document).on('click', '.js-variationSelected', function (e) {
        var $productContainer = $(this).closest('.product');
        var $selectedButton = $(this).closest('.cc-prod__switch');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.js-prod-tile');
        }
        e.preventDefault();
        if ($(this).attr('disabled')) {
            return;
        }
        attributeSelect($(this).attr('data-url'), $productContainer, $selectedButton);
    });
}

export function beforeUpdateAttribute() {
    $('body').on('product:beforeVariationSelect', function () {
        $('.js-prod-tile').spinner().start();
    });
}

export function updateAttribute() {
    $('body').on('product:afterVariationSelect', function (e, response) {
        //Display the selected variation
        $(response.button).closest('.js-variationSelected').siblings().removeClass('cc-prod-switch__active');
        $(response.button).closest('.js-variationSelected').addClass('cc-prod-switch__active');
    });
}

export function quickAddToCart() {
    $(document).on('click', 'button.js-tile-quick-add-btn, button.quick-add-to-cart-global', function () {
        var addToCartUrl;
        var pid;
        var pidsObj;
        var setPids;

        $('body').trigger('product:beforeAddToCart', this);

        if ($('.set-items').length && $(this).hasClass('quick-add-to-cart-global')) {
            setPids = [];

            $('.js-prod-tile').each(function () {
                if (!$(this).hasClass('product-set-detail')) {
                    setPids.push({
                        pid: $(this).find('.product-id').text(),
                        qty: $(this).find('.quantity-select').val(),
                        options: getOptions($(this)),
                    });
                }
            });
            pidsObj = JSON.stringify(setPids);
        }

        pid = getPidValue($(this));

        var $productContainer = $(this).closest('.js-prod-tile');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.product').find('.js-prod-tile');
        }

        addToCartUrl = getAddToCartUrl($productContainer);

        var form = {
            pid: pid,
            pidsObj: pidsObj,
            childProducts: getChildProducts(),
            quantity: 1,
        };

        if (!$('.bundle-item').length) {
            form.options = getOptions($productContainer);
        }

        $(this).trigger('updateAddToCartFormData', form);
        if (addToCartUrl) {
            $.spinner().start();
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: (data) => {
                    if (!data.error) {
                        $('body').trigger('product:afterAddToCart', data);
                        $('.minicart .minicart-quantity').html(data.quantityTotal);

                        var prodImageHtml = $($productContainer).find('.cc-prod-tile__img').html();
                        if (prodImageHtml) {
                            prodImageHtml = prodImageHtml.replace(/\/medium\//g, '/small/');
                            $('.js-prod-image').html(prodImageHtml);
                            $('.js-prod-image').find('img').attr('alt', '');
                        }

                        $('.js-prod-name').text($($productContainer).find('.cc-prod-tile__name').text());

                        $('.js-prod-prices').html($($productContainer).find('.cc-prod-tile__prices').html());
                        $('.js-prod-prices').find('[data-toggle="tooltip"]').tooltip({ html: true, container: 'body' });

                        $('.js-prod-rating').html($($productContainer).find('.cc-prod-tile__rating').html());

                        $('#addToCartProductModal').find('.js-suggested-tile-add-btn').removeClass('d-none');
                        $('#addToCartProductModal').find('.js-suggested-added').addClass('d-none');

                        var $suggestedContainer = $('#addToCartProductModal .js-suggested-products');
                        $suggestedContainer.empty();

                        $('#addToCartProductModal').modal('show');

                        $.spinner().stop();
                        miniCartReportingUrl(data.reportingURL);
                    } else {
                        handleError();
                    }

                },
                error: function () {
                    handleError();
                },
            });
        }
    });
}
export function quickSuggestedAddToCart() {
    $(document).on('click', 'button.js-suggested-tile-add-btn', function () {
        var addToCartUrl;
        var pid;
        var pidsObj;
        var setPids;

        $('body').trigger('product:beforeAddToCart', this);

        if ($('.set-items').length && $(this).hasClass('quick-add-to-cart-global')) {
            setPids = [];

            $('.js-suggested-prod-tile').each(function () {
                if (!$(this).hasClass('product-set-detail')) {
                    setPids.push({
                        pid: $(this).find('.product-id').text(),
                        qty: $(this).find('.quantity-select').val(),
                        options: getOptions($(this)),
                    });
                }
            });
            pidsObj = JSON.stringify(setPids);
        }

        pid = getSuggestedPidValue($(this));

        var $productContainer = $(this).closest('.js-suggested-prod-tile');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.product').find('.js-suggested-prod-tile');
        }

        addToCartUrl = getAddToCartUrl($productContainer);

        var form = {
            pid: pid,
            pidsObj: pidsObj,
            childProducts: getChildProducts(),
            quantity: 1,
        };

        if (!$('.bundle-item').length) {
            form.options = getOptions($productContainer);
        }

        $(this).trigger('updateAddToCartFormData', form);
        if (addToCartUrl) {
            $.spinner().start();
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: (data) => {
                    if (!data.error) {
                        $('body').trigger('product:afterAddToCart', data);
                        $('.minicart .minicart-quantity').html(data.quantityTotal);

                        $productContainer.find('.js-suggested-tile-add-btn').addClass('d-none');
                        $productContainer.find('.js-suggested-added').removeClass('d-none');

                        $.spinner().stop();
                        miniCartReportingUrl(data.reportingURL);
                    } else {
                        handleError();
                    }

                },
                error: function () {
                    handleError();
                },
            });
        }
    });
}

export function addCoffeeMatchToCart() {
    $(document).on('click', 'button.js-addCoffeeMatchToCart', function () {
        var addToCartUrl;
        var pid;
        var pidsObj;
        var setPids;

        $('body').trigger('product:beforeAddToCart', this);

        var $productContainer = $(this).closest('.cc-account__coffeeMatch__item');

        if ($('.set-items').length && $(this).hasClass('quick-add-to-cart-global')) {
            setPids = [];

            $('.cc-account__coffeeMatch__item').each(function () {
                if (!$(this).hasClass('product-set-detail')) {
                    setPids.push({
                        pid: $(this).attr('data-product-id'),
                        qty: 1,
                        options: getOptions($(this)),
                    });
                }
            });
            pidsObj = JSON.stringify(setPids);
        }

        // Get product ID from data attribute
        pid = $productContainer.attr('data-product-id');

        addToCartUrl = getAddToCartUrl($productContainer);

        var form = {
            pid: pid,
            pidsObj: pidsObj,
            childProducts: getChildProducts(),
            quantity: 1,
        };

        if (!$('.bundle-item').length) {
            form.options = getOptions($productContainer);
        }

        $(this).trigger('updateAddToCartFormData', form);
        if (addToCartUrl) {
            $.spinner().start();
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: (data) => {
                    if (!data.error) {
                        $('body').trigger('product:afterAddToCart', data);
                        $('.minicart .minicart-quantity').html(data.quantityTotal);

                        $productContainer.find('.js-addCoffeeMatchToCart').addClass('d-none');
                        $productContainer.find('.js-addedCoffeeMatchToCart').removeClass('d-none');

                        setTimeout(function () {
                            $productContainer.find('.js-addCoffeeMatchToCart').removeClass('d-none');
                            $productContainer.find('.js-addedCoffeeMatchToCart').addClass('d-none');
                        }, 2000);

                        $.spinner().stop();
                        miniCartReportingUrl(data.reportingURL);
                    } else {
                        handleError();
                    }

                },
                error: function () {
                    handleError();
                },
            });
        }
    });
}

export function addCoffeeMatchModalToCart() {
    $(document).on('click', 'button.cc-account__coffeeMatch__modalItem__button', function () {
        var addToCartUrl;
        var pid;

        $('body').trigger('product:beforeAddToCart', this);

        // Get product ID from button's data attribute
        pid = $(this).data('product-id');

        addToCartUrl = $('.quick-add-to-cart-url').val();

        var form = {
            pid: pid,
            quantity: 1,
        };

        $(this).trigger('updateAddToCartFormData', form);
        if (addToCartUrl && pid) {
            $.spinner().start();
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: (data) => {
                    if (!data.error) {
                        $('body').trigger('product:afterAddToCart', data);
                        $('.minicart .minicart-quantity').html(data.quantityTotal);

                        $.spinner().stop();
                        miniCartReportingUrl(data.reportingURL);
                    } else {
                        handleError();
                    }

                },
                error: function () {
                    handleError();
                },
            });
        }
    });
}
